$(document).ready(function(){
 
  if(location.pathname.includes("products"))
  {
    let imageElement = $(".lazyloads");
      Array.from(imageElement).forEach(function(element){
        let attribute = element.dataset.src;
        $(element).attr("src", attribute)
      });
  
  }
  else
  {
  	let isOpen = false;
  $(window).on('scroll', function() {
    var y_scroll_pos = $(window).scrollTop();
    var scroll_pos_test = 150;             // set to whatever you want it to be

    if(y_scroll_pos > 10 && !isOpen ) {
      if(location.pathname == "/"){
      	yett.unblock();
      }
      isOpen = true;
      let imageElement = $(".lazyloads");
      Array.from(imageElement).forEach(function(element){
        let attribute = element.dataset.src;
        $(element).attr("src", attribute)
      });
      //do stuff
    }
  });
  }
	//lazyloads
  
})